#@import moment
#@export GliveBooking.Models.Event

class GliveBooking.Models.Event extends BookingV2.Models.Base

  initialize: ->
    eventStartAt = moment.unix @get('eventStartAt')

    unless @get('userMax')? && @get('quantitySummary')?.estimatedRemainingQuantity?
      throw "Invalid availability data"


    maxQuantity = Math.min(@get('userMax'), @get('quantitySummary').estimatedRemainingQuantity)

    @set
      eventStartAt: eventStartAt
      time: new GliveBooking.Models.Time(initial_time: @get('eventStartAt'), final_time: null)
      section: new GliveBooking.Models.Section(title: @get('section'))
      price: new GliveBooking.Models.Price(price: @get('priceSummary').price, value: @get('priceSummary').value, discount: @get('priceSummary').discount, savings: @get('priceSummary').savings)
      maxQuantity: maxQuantity

  getUUID: ->
    @get('uuid')

  getUserMin: ->
    @get('userMin')

  getQuantityOptions: ->
    maxQuantity = @getMaxQuantity()
    _.reject [@getUserMin()..maxQuantity], (num) ->
      num == maxQuantity - 1

  getMaxQuantity: ->
    @get('maxQuantity')

  getTime: ->
    @get('time')

  getPrice: ->
    @get('price')

  getSection: ->
    @get('section')
